export default __webpack_public_path__ + "static/media/cainta.f2db6484.jpg";